export const environment = {
    production: false,
    apiUrl: 'https://api.cca.preprod-s4.cawita.com',
    assetUrl: 'https://assets.cca.preprod-s4.cawita.com',
    customerSpaceUrl: 'https://share.cca.preprod-s4.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR'
};